import { StyledHamburgerButton, StyledLine, StyledSRText } from './HamburgerButton.styles';

type HamburgerButtonProps = {
  handleOnClick: () => void;
  isActive: boolean;
  className?: string;
};

const HamburgerButton = ({ handleOnClick, isActive, className }: HamburgerButtonProps) => (
  <StyledHamburgerButton
    onClick={handleOnClick}
    className={className}
    isActive={isActive}
    aria-expanded={isActive}
  >
    <StyledLine />
    <StyledLine />
    <StyledLine />
    <StyledSRText>Mobile menu toggle button</StyledSRText>
  </StyledHamburgerButton>
);

export default HamburgerButton;
